/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires these libraries to be loaded first
* jQuery
* Underscore.js
* moment.js
*/

var Developer = {
  getAuthToken : function(username, password, callback) {
    var xhr = new window.XMLHttpRequest()
    xhr.open('POST', 'https://developers.karmadata.com/request_developer_token', true)
    xhr.setRequestHeader('Content-type', 'application/json')
    // xhr.setRequestHeader('Accpet', 'application/json')
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var result = JSON.parse(xhr.responseText)
          if (!result.success) throw result.error
          callback(null, result.token.access_token)
        } catch(e) {
          callback(e)
        }
      } else {
        var e = xhr.responseText || 'Unknown Error'
        callback(e)
      }
    }
    xhr.send(JSON.stringify({username: username, password: password}))
  }
}

exports.Developer = Developer



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.Developer.js
// module id = 206
// module chunks = 0